import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, Col, Row, Spinner } from 'react-bootstrap';
import { Container } from "reactstrap";
import { Switch, Breadcrumbs, FormControlLabel, TextField } from '@mui/material';
import { company_name, GetSchema, company_tel, company_country, string_required } from '../../../js/Base/ValidationSchema';
import { InputFormFiled } from '../../../components/Common/FormikField/InputFormFiled';
import { InputField } from '../../../components/Common/FormikField/InputField';
import { Formik, Form, Field } from 'formik';
import toastAlert from '../../../js/Base/ToastAlert';
import { GreenSwitch } from '../../../components/Common/GreenSwitch';
import TimezoneSelect from "react-timezone-select";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CompanyBaseInfoCard from './CompanyBaseInfoCard';
import SystemAuthCard from './SystemAuthCard';
import { getCompanyById } from '../../../api/companyApi';

export default function CompanyBaseInfo() {
  const [loading, setLoading] = useState(true);
  const [mfaActive, setMfaActive] = useState(false);
  const [initialValues, setInitialValues] = useState({
    name: "",
    enable_mfa: false,
    country: "",
    address: "",
    tel: "",
    company_owner: "",
    eng_name: "",
    timezone: "",
    report_logo_pic: "",
  });
  const [companyInfo, setCompanyInfo] = useState(null);

  useEffect(() => {
    getCompanyByNo();
  }, []);

  const getCompanyByNo = async () => {
    const companyUuid = localStorage.getItem('company_uuid');

    if (!companyUuid) {
      toastAlert.autoClose(true).showError("查無資料，請聯絡系統管理員");
      return;
    }

    setLoading(true);

    try {
      const response = await getCompanyById(companyUuid);
      const data = response.data;

      if (!data.success || !data.company) {
        toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
        return;
      }

      const company = data.company;
      setMfaActive(company.enable_mfa);
      setCompanyInfo(company);
      setInitialValues({
        name: company.name || "",
        company_owner: company.company_owner || "",
        eng_name: company.eng_name || "",
        country: company.country || "",
        address: company.address || "",
        tel: company.tel || "",
        timezone: company.timezone || "",
        report_logo_pic: company.report_logo_pic || "",
      });
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
    } finally {
      setLoading(false);
    }
  };

  const handleSwitchChange = (e) => {
    setMfaActive(e.target.checked);
    // setInitialValues((prev) => ({
    //   ...prev,
    //   enable_mfa: e.target.checked,
    // }));
  };

  return (
    <React.Fragment>
      <Container className="mt-2">
        <div>
          <Breadcrumbs
            className="link-area"
            style={{ padding: "0 0 20px 0", fontWeight: 'bold'}}
            separator={<NavigateNextIcon style={{ fontSize: '20px', fontWeight: 'bold' }} />}
            aria-label="breadcrumb"
          >
            <Link to="/admin-management" style={{ color: '#1d1d1d', fontSize: '20px', textDecoration: 'none', fontWeight: 'bold' }}>
              <p style={{ marginBottom: '0px' }}>公司管理</p>
            </Link>
            <Link to="/company/company-base-info" style={{ color: '#1d1d1d', fontSize: '20px', textDecoration: 'none', fontWeight: 'bold' }}>
              <p style={{ marginBottom: '0px' }}>基本資料</p>
            </Link>
          </Breadcrumbs>
          {loading ? (
            <div className="d-flex justify-content-center my-3">
              <Spinner animation="border" role="status" />
            </div>
          ) : (
            <>
            <CompanyBaseInfoCard company={companyInfo} />
            <SystemAuthCard company={companyInfo} />
            </>
          )}
        </div>
      </Container>
    </React.Fragment>
  );
}
